import React from "react";
import SEO from "@/components/SEO";
import LocationTemplate from "@/components/LocationTemplate";

const SomertonPage = () => <LocationTemplate suburbName="Somerton" suburbSlug="somerton" />;

export default SomertonPage;
